import BaseModel from '../base/BaseModel.model';
import RolePermission from './rolePermission.model';
import { Sex } from '@/enums/Sex';
import { IdentificationType } from '@/enums/IdentificationType';
import CertificationUser from '../curriculum/certificationUser.Model';
import MasterEducation from '../curriculum/masterEducation.Model';
import PublicactionUser from '../curriculum/publicactionUser.Model';
import UserLanguage from '../curriculum/userLanguage.Model';
import ExperienceUser from '../curriculum/experienceUser.Model';
import ContactUser from '../curriculum/contactUser.Model';
import Association from '../curriculum/association.Model';
import ReferenceUser from '../curriculum/referenceUser.Model';
import ScientificMagazine from '../curriculum/scientificMagazine.Model';
import PeerReviewer from '../curriculum/PeerReviewers.Model';
import DocoralCommittee from '../curriculum/doctoralCommittee';
import DoctoralThesi from '../curriculum/doctoralThesi.Model';
import UserDocument from './userDocument.model';


export default class User extends BaseModel {

    public id: number = 0;
    public name: string = "";
    public orcid: string = "";
    public deleted: any; 
    public lastName: string = "";
    public fullName: string ="";
    public email: string = "";
    public adid: string = "";
    public permissions: Array<RolePermission> = [];
    public roles: Array<any> = [];
    public userRoles: Array<any> = [];
    public biography: string  = "";
    public biographyUI: string  = "";
    
    public hasCarrerCode: Boolean | any;
    public isAdmin :boolean = false;
    public careerCode: string = "";
    public dob: Date | null = null;
    public sex: Sex = Sex.FEMALE;
    public code: string="";
    public hasCode:Boolean = false;
    public countryId: number | null = null;
    public identificationType: IdentificationType = IdentificationType.IDENTIFICATIONCARD;
    public identification: string | null= null;
    public isEditorialMember: Boolean | any;
    public isPeerReviewer: Boolean | any;
    public isDoctoralCommittee: Boolean | any;
    public isDoctoralThesi: Boolean | any;
    public personalPhoneNumber:string | any;

    
    public userDocuments: Array<UserDocument> = [];
    public academicAreaId: number | null = null;
    public academicTitleId: number | null = null;
    public isYourActualWork:Boolean =  false;
    public certificationUsers: Array<CertificationUser> = [];
    public masterEducations:Array<MasterEducation> = [];
    public publicactionUsers: Array<PublicactionUser> = [];
    public userLanguages:Array<UserLanguage> = [];
    public experienceUsers: Array<ExperienceUser> = [];
    public contactUsers: Array<ContactUser> = [];
    public associations: Array<Association> = [];
    public referenceUsers: Array<ReferenceUser> = [];
    public scientificMagazines : Array<ScientificMagazine> = [];
    public docoralCommittees : Array<DocoralCommittee> = [];
    public peerReviewers : Array<PeerReviewer> = [];
    public doctoralThesis : Array<DoctoralThesi> = [];

    
    
    constructor(){
        super();
        this.init();
    }

    init(){
        this.id = 0;
        this.name = "";
        this.orcid = "";
        this.lastName = "";
        this.fullName = "";
        this.nameCode = "";
        this.hasCode = false;
        this.email = "";
        this.deleted = undefined;
        this.biography = "";
        this.biographyUI = "";
        this.personalPhoneNumber = "";
        this.adid = "";
        this.permissions = [];
        this.roles = [];
        this.userRoles = [];
        this.isAdmin = false;
        this.dob = null;
        this.sex = Sex.FEMALE;
        this.code = "";
        this.isYourActualWork = false;
        this.countryId = null;
        this.identificationType = IdentificationType.IDENTIFICATIONCARD;
        this.identification =  null;
        this.certificationUsers = [];
        this.masterEducations = [];
        this.userLanguages = [];
        this.publicactionUsers =  [];
        this.experienceUsers = [];
        this.associations = [];
        this.academicAreaId = null;
        this.academicTitleId = null;
        this.contactUsers = [];
        this.referenceUsers = [];
        this.careerCode = "";
        this.isEditorialMember = false;
        this.scientificMagazines = [];
        this.peerReviewers = [];
        this.isPeerReviewer = false;
        this.docoralCommittees = [];
        this.userDocuments = [];
        this.doctoralThesis = [];
        this.isDoctoralThesi = false;
        this.isDoctoralCommittee = false;
        this.disabled = false;
    }
}